import React from 'react';
import { APP_CONTAINER_ROUTES } from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { SelectTagPrintBatchTemplate } from './select-tag-print-batch-template';
import { StackNavigationProp } from '@react-navigation/stack';
import { useNavigation } from '@react-navigation/native';

type Navigation = StackNavigationProp<
  AppContainerStackParams,
  APP_CONTAINER_ROUTES.CustomTagPrint
>;

interface Props {
  onClose: () => void;
}

/**
 * Template picker for a one-off tag printed from hand-entered values. Unlike a
 * batch, nothing is persisted here — the selected template is handed straight
 * to the custom tag form.
 */
export const CustomTagTemplateActionSheet: React.FC<Props> = ({ onClose }) => {
  const { navigate } = useNavigation<Navigation>();

  return (
    <BaseActionSheet isVisible onClose={onClose}>
      <SelectTagPrintBatchTemplate
        hideChangeLaterMessage
        initialTemplate={null}
        onSelectTemplate={(selectedTemplate) => {
          if (selectedTemplate) {
            navigate(APP_CONTAINER_ROUTES.CustomTagPrint, {
              printTagTemplateUUID: selectedTemplate.uuid,
            });
            onClose();
          }
        }}
        requireLocalRendering
      />
    </BaseActionSheet>
  );
};
